import {call, put, takeLatest} from 'redux-saga/effects';
import GamesApi from '../../api/GamesApi';
import errorActions from '../../actions/error.actions';
import {gamesActions} from '../../actions/fortnite-game';
import getErrorFromResponse from '../../utils/errors/getErrorFromResponse';

function* getGames(action) {
    try {
        const {data} = yield call(GamesApi.getList, action.payload);
        yield put(gamesActions.getGamesSuccess({data}));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(gamesActions.getGamesFailed(getErrorFromResponse(e), e));
    }
}

function* gamesSaga() {
    yield takeLatest(gamesActions.TYPES.GET_GAMES, getGames);
}

export default gamesSaga;
